import { Button } from '@platform/components';

/** Partner landing CTA with accent stripe and vertically centered button. Keeps CTACard unchanged for other pages. */
const PartnerLandingCTACard = ({
  title,
  description,
  signUpUrl,
}: {
  title: string;
  description: string;
  signUpUrl: string;
}) => {
  const shadow =
    '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)';
  const stripeColor = 'bg-accent-500';

  return (
    <div className={`pt-16 ${stripeColor}`}>
      <div className='px-4 sm:px-8 lg:px-[112px]'>
        <div className='relative max-w-[1440px] mx-auto'>
          <div
            className='relative px-6 sm:px-16 pt-10 sm:pt-16 pb-10 sm:pb-16 rounded-2xl bg-gray-50'
            style={{ boxShadow: shadow }}
          >
            <div className='sm:max-w-[768px] sm:pr-48 text-3xl font-semibold leading-9 text-gray-800'>
              {title}
            </div>
            <div className='sm:max-w-[768px] sm:pr-48 text-xl leading-7 text-gray-500 mt-2'>
              {description}
            </div>
            <div className='sm:hidden mt-8'>
              <Button variant='primary' size='xl' href={signUpUrl}>
                Get started
              </Button>
            </div>
            <div className='hidden sm:flex sm:absolute sm:inset-0 sm:items-center sm:justify-end sm:pr-16 sm:pointer-events-none'>
              <div className='pointer-events-auto'>
                <Button variant='primary' size='2xl' href={signUpUrl}>
                  Get started
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${stripeColor} pb-16`} />
    </div>
  );
};

export default PartnerLandingCTACard;
